class ArticleCard extends HTMLElement {
  constructor() {
    super();

    this.contentLower = this.querySelector(".card__inner");
    this.excerpt = this.contentLower.querySelector(".card__excerpt");

    const width = getComputedStyle(this.excerpt).width;

    // Set properties to calculate height whilst hiding element
    this.excerpt.style.width = width;
    this.excerpt.style.position = "absolute";
    this.excerpt.style.visibility = "hidden";
    this.excerpt.style.height = "auto";

    const height = getComputedStyle(this.excerpt).height;

    // Reset properties used above to calculate height
    this.excerpt.style.width = null;
    this.excerpt.style.position = null;
    this.excerpt.style.visibility = null;
    this.excerpt.style.height = "0";

    // Force repaint
    getComputedStyle(this.excerpt).height;
    requestAnimationFrame(() => (this.excerpt.style.height = height));
    this.excerpt.classList.add("no-height");
  }
}

customElements.define("article-card", ArticleCard);
